import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { C3PositionsEdit } from "./edit";
import { C3PositionsNew } from "./new";
import { C3PositionsTable } from "./table";

export default function C3Positions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Positions");
  }, []);

  return (
    <Routes>
      <Route path="new" element={<C3PositionsNew />} />
      <Route path=":id" element={<C3PositionsEdit />} />
      <Route index element={<C3PositionsTable />} />
    </Routes>
  );
}
